import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { CustomModalLayout, Stepper } from '@wix/design-system';

import s from '../modals.scss';
import { AppContextProvider } from '../../../AppLoader';
import { UiStore } from './AddPhoneUiStore';
import { AddPhoneStepContent } from './AddPhoneStepContent';

export const AddPhoneStep: React.FC = observer(() => {
  const {
    rootStore: {
      postLoginStore: {
        premiumUsers2FaEnforcementStore: { add2FAPhoneStore: store },
      },
    },
  } = useContext(AppContextProvider);
  const uiStore = new UiStore(store);
  const ownerAppStore = store.premiumUsers2FaEnforcementStore.ownerAppStore;
  const content = (
    <div className={s.addPhoneContainer}>
      {uiStore.showStepper && (
        <div className={s.stepper}>
          <Stepper
            type="text"
            activeStep={ownerAppStore.activeStep}
            steps={ownerAppStore.steps}
          />
        </div>
      )}
      <AddPhoneStepContent />
    </div>
  );
  return (
    <CustomModalLayout
      title={uiStore.title}
      subtitle={uiStore.subtitle}
      primaryButtonText={uiStore.primaryButtonText}
      primaryButtonOnClick={uiStore.primaryButtonOnClick}
      sideActions={uiStore.sideActions}
      className={s.enforcementSmsModal}
      removeContentPadding
      primaryButtonProps={{
        disabled: store.shouldDisableSubmit,
      }}
      showHeaderDivider
    >
      {content}
    </CustomModalLayout>
  );
});
